import { createSelector } from 'reselect';

export const selectTheme = (state: any) => state.theme;

export const selectCurrent = createSelector([selectTheme], (theme) => theme.value);


